export const RECAPTCH_CONTAINER_ID = "recaptcha-container";
export const RECAPTCHA_REAUTH_CONTAINER_SUFFIX = "-reauth";
export const SERVER_URL =
  process.env.REACT_APP_ENV_VAR === "dev"
    ? "server-certificates-dot-ptts-certificates.ew.r.appspot.com:8080"
    : "server-certificates-dot-ptts-certificates.ew.r.appspot.com";
export const PROTOCOL =
  process.env.NODE_ENV === "test" || process.env.REACT_APP_ENV_VAR === "dev"
    ? "http://"
    : "https://";
export const roles = {
  ADMIN: 1,
  BASIC: 0,
};
